<template>
  <div
    v-intersect-on.once
    @intersect="intersectEventHandler"
    class="d-businessCustomerVoice"
  >
    <DSwiper
      class="d-businessCustomerVoice_swiper"
      :is-enable-swiper="isPc"
      :item-view-count="3"
      :item-style="{
        width: 360,
        marginRight: 40,
      }"
      :pagenation="false"
      :autoplay="autoplay"
    >
      <DSwiperItem
        v-for="(customerVoice, index) in customerVoiceList"
        :key="`customerVoiceSwiper_${index}`"
        class="d-businessCustomerInfo"
      >
        <a
          :href="customerVoice.href"
          target="_blank"
          rel="noopener"
        >
          <img
            class="d-businessCustomerInfo_image"
            :src="$coconala.fileURL(customerVoice.image.src)"
            :alt="customerVoice.image.alt"
            width="360"
            height="240"
            loading="lazy"
          >
          <div class="d-businessCustomerInfo_content">
            <h3 class="d-businessCustomerInfo_title">{{ customerVoice.title }}</h3>
            <p class="d-businessCustomerInfo_description">{{ customerVoice.description }}</p>
          </div>
        </a>
      </DSwiperItem>
    </DSwiper>
  </div>
</template>

<script>
import DSwiper from '~/components/molecules/DS2/DSwiper'
import DSwiperItem from '~/components/molecules/DS2/DSwiper/components/DSwiperItem'

/** @type {import('vue').ComponentOptions} */
const DBusinessCustomerVoiceSwiper = {
  name: 'DBusinessCustomerVoiceSwiper',
  components: {
    DSwiper,
    DSwiperItem
  },
  props: {
    isPc: {
      type: Boolean,
      default: true
    },
    customerVoiceList: {
      type: Array,
      required: true,
      validator: value => {
        const property = ['title', 'description', 'href', 'image']
        return property.every(p => value.every(v => v.hasOwnProperty(p)))
      }
    }
  },
  data() {
    return {
      autoplay: false
    }
  },
  methods: {
    /**
     * カルーセルが表示画面内に表示されたら発火
     */
    intersectEventHandler() {
      if (this.isPc) {
        this.autoplay = true
      }
    }
  }
}

export default DBusinessCustomerVoiceSwiper
</script>

<style lang="scss" scoped>
$slide-content-tb-width: 280px;
$slide-content-sp-width: 200px;

.d-businessCustomerVoice {
  height: 388px;
  margin-bottom: 48px;
}
.d-businessCustomerInfo {
  border-radius: 8px;
  filter: drop-shadow(0 2px 6px rgba(2, 16, 66, 0.1));

  &_image {
    border-radius: 8px 8px 0 0;
  }
  &_content {
    height: 130px;
    padding: 20px;
    background: $ds2-color-white;
    border-radius: 0 0 8px 8px;
  }
  &_title {
    margin-bottom: 10px;
    color: $ds2-color-brand-primary;
    font-weight: bold;
  }
  &_description {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 13px;
    color: $ds2-color-gray-900;
    &-space {
      margin-right: 15px;
    }
  }
}

@media (max-width: breakpoint(BusinessTop, M)) {
  .d-businessCustomerVoice {
    overflow-x: scroll;
    height: 352px;

    // ios用
    -webkit-overflow-scrolling: touch;
    justify-content: unset;
    margin-bottom: 30px;

    &_swiper {
      padding: 0 16px;
    }
  }
  .d-businessCustomerInfo {
    width: $slide-content-tb-width !important;
    padding-bottom: 10px;
    margin-right: 16px !important;
  }
}

@media (max-width: breakpoint(BusinessTop, S)) {
  .d-businessCustomerVoice {
    height: 320px;
  }
  .d-businessCustomerInfo {
    width: $slide-content-sp-width !important;
    margin-right: 8px !important;
    &_content {
      height: 160px;
    }
  }
}
</style>
